import { render } from "./BaseCheckbox.vue?vue&type=template&id=157c8038&scoped=true"
import script from "./BaseCheckbox.vue?vue&type=script&lang=js"
export * from "./BaseCheckbox.vue?vue&type=script&lang=js"

import "./BaseCheckbox.vue?vue&type=style&index=0&id=157c8038&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-157c8038"],['__file',"src/components/BaseCheckbox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "157c8038"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('157c8038', __exports__)) {
    api.reload('157c8038', __exports__)
  }
  
  module.hot.accept("./BaseCheckbox.vue?vue&type=template&id=157c8038&scoped=true", () => {
    api.rerender('157c8038', render)
  })

}


export default __exports__